import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import AmplifyApiService from '../../services/AmplifyApiService';
import IAmplifyApiConfig from '../../shared/interfaces/IAmplifyApiConfig';

type ImportFileProps = {
  file: File;
  type: FileImportType;
};

type ImportProductPCFFileProps = {
  file: File;
};

const amplifyApiService = new AmplifyApiService();

const BASE_PATH = 'imports';

export enum FileImportType {
  IMPORT_PRODUCTS = 'import_products',
  ASSIGN_PRODUCTS = 'assign_products',
}

export const useImportFile = (
  options: UseMutationOptions<void, Error, ImportFileProps> = {},
): UseMutationResult<void, Error, ImportFileProps> => {
  const mutation = useMutation<void, Error, ImportFileProps>({
    mutationFn: async (props: ImportFileProps): Promise<void> => {
      const { file, type } = props;

      const formData = new FormData();
      formData.append('file', file);
      formData.append('type', type);

      const amplifyApiConfig: IAmplifyApiConfig = {
        apiName: 'PacificApi',
        path: `${BASE_PATH}/file`,
        options: {
          body: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      };

      return await amplifyApiService.post<FormData, void>(amplifyApiConfig);
    },
    ...options,
  });

  return mutation;
};

export const useImportProductPCFFile = (
  options: UseMutationOptions<void, Error, ImportProductPCFFileProps> = {},
): UseMutationResult<void, Error, ImportProductPCFFileProps> => {
  const mutation = useMutation<void, Error, ImportProductPCFFileProps>({
    mutationFn: async (props: ImportProductPCFFileProps): Promise<void> => {
      const { file } = props;

      const formData = new FormData();
      formData.append('file', file);

      const amplifyApiConfig: IAmplifyApiConfig = {
        apiName: 'PacificApi',
        path: `${BASE_PATH}/product-pcf`,
        options: {
          body: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      };

      return await amplifyApiService.post<FormData, void>(amplifyApiConfig);
    },
    ...options,
  });

  return mutation;
};
